// Runtime webpack public path override for the WordPress theme build.
// The WP theme injects `window.__eurekaPublicPath__` (theme assets URL with
// trailing slash) *before* the main bundle runs. We point webpack's chunk
// loader at that path so lazy chunks resolve correctly inside WordPress.
// In dev / standalone builds the global is undefined and this is a no-op.
/* eslint-disable no-undef, camelcase */
if (typeof window !== 'undefined' && typeof window.__eurekaPublicPath__ === 'string' && window.__eurekaPublicPath__) {
  __webpack_public_path__ = window.__eurekaPublicPath__;
}
